import { sessionGetItemObj } from '../../../utils/sessionHelpers'

export function convertDataReportAudit(dataObj, formId = '') {
  if (dataObj) {
    const data = dataObj
    const auditInfo = sessionGetItemObj('auditInfo')

    //conditions check if
    const conditionsArray = [
      'auditByCompany',
      'auditName',
      'auditResults',
      'description',
      'projectGrade',
      'auditorOption',
      'auditPeriod',
      // 'auditorCompany',
      // 'auditorName',
      'auditorLicenseNumber',
      'auditDate',
      'auditBudgetYear',
    ]

    let newArr = [],
      idArr = [],
      issueCodeArr = [],
      riskLevelArr = [],
      issuesDetectedArr = [],
      explanationArr = [],
      explanationResultArr = [],
      auditBudgetIdArr = [],
      auditPeriodArr = [],
      auditorCompanyArr = [],
      auditorNameArr = [],
      auditorLicenseNumberArr = [],
      budgetsArr = [],
      count = 0

    for (const key in data) {
      if (!conditionsArray.includes(key)) {
        // console.log('key => ', key)
        count = count + 1

        // convert json key to array
        let keyArr = key.split('_')

        if (keyArr.length == 3) {
          if (count % 4 == 0) {
            issueCodeArr.push(keyArr[0])
            keyArr[1].indexOf('ADDNEW') != -1 ? idArr.push(null) : idArr.push(keyArr[1])
          }

          // !riskLevelArr.includes(data[key]) &&
          if (keyArr[2] == 'risk') {
            riskLevelArr.push(data[key])
          }

          // !issuesDetectedArr.includes(data[key]) &&
          if (keyArr[2] == 'issuesDetected') {
            issuesDetectedArr.push(data[key])
          }

          // !explanationArr.includes(data[key]) &&
          if (keyArr[2] == 'explanation') {
            explanationArr.push(data[key])
          }

          if (keyArr[2] == 'explanationResult') {
            explanationResultArr.push(data[key])
          }
        } else {
          console.log('keyArr => ', keyArr[0].indexOf('INSERT'), keyArr, data[key])

          if (count % 4 == 0) {
            keyArr[0].indexOf('INSERT') != -1
              ? auditBudgetIdArr.push(null)
              : auditBudgetIdArr.push(keyArr[0])
          }

          if (keyArr[1] == 'auditPeriod') {
            auditPeriodArr.push(data[key])
          }

          if (keyArr[1] == 'auditorCompany') {
            auditorCompanyArr.push(data[key])
          }

          if (keyArr[1] == 'auditorName') {
            auditorNameArr.push(data[key])
          }

          if (keyArr[1] == 'auditorLicenseNumber') {
            auditorLicenseNumberArr.push(data[key])
          }
        }
      }
    }

    auditBudgetIdArr.map((item, index) => {
      budgetsArr.push({
        id: item,
        auditPeriod: auditPeriodArr[index] || 0,
        auditorCompany: auditorCompanyArr[index] || '',
        auditorName: auditorNameArr[index] || '',
        auditorLicenseNumber: auditorLicenseNumberArr[index] || '',
      })
    })

    idArr.map((item, index) => {
      newArr.push({
        id: item || null,
        issueCode: issueCodeArr[index] || null,
        riskLevel: riskLevelArr[index] || 0,
        issuesDetected: issuesDetectedArr[index] || null,
        explanation: explanationArr[index] || null,
        explanationResult: explanationResultArr[index] || 0,
      })
    })

    const request = {
      id: formId || '',
      projectCode: auditInfo.projectCode || '',
      budgetYear: data?.auditBudgetYear || 0,
      auditTeam: data?.auditByCompany || '',
      auditor: data?.auditName || '',
      auditorLicenseNumber: data?.auditorLicenseNumber || '',
      auditResults: data?.auditResults,
      auditDate: data?.auditDate || null,
      grade: data?.projectGrade || 0,
      overview: data?.description || '',
      otherDesc: data?.otherDesc || '',
      auditorOpinion: data.auditorOption || 0,
      auditPeriod: data.auditPeriod || 0,
      comment: '',
      budgets: budgetsArr,
      details: newArr,
    }

    return request
  }
  return null
}

export function convertFollowAuditIssues(dataObj, formId = '') {
  if (dataObj) {
    const data = dataObj
    //const auditInfo = sessionGetItemObj('auditInfo')

    //conditions check if
    const conditionsArray = [
      'attachFiles',
      // 'coordinatorOption',
      'DeleteFileIds',
      'coordinatorComment',
      'validApproveOption',
    ]

    let keyIdArr = [],
      trackingResultsArr = [],
      trackingResultsDetailArr = [],
      newFilesIdArr = [],
      newFilesIssueCodeArr = [],
      newFiles = [],
      count = 0
    for (const key in data) {
      if (!conditionsArray.includes(key)) {
        count = count + 1

        let keyArr = key.split('_')

        if (keyArr.length == 3) {
          console.log('keyArr ', keyArr)
          //นว == 0
          if (count % 2 == 0) {
            // if (count % 4 == 0) {
            keyIdArr.push(keyArr[1])
          }

          if (keyArr[2] == 'trackingResults') {
            trackingResultsArr.push(data[key])
          }

          if (keyArr[2] == 'trackingResultsDetail') {
            trackingResultsDetailArr.push(data[key])
          }
        }

        if (keyArr.length == 2 && data[key].length > 0 && data[key] != '') {
          newFilesIdArr.push(null)
          newFilesIssueCodeArr.push(keyArr[0])
          newFiles.push(data[key])
        }
      }
    }

    const formData = new FormData()

    formData.append('id', formId || '')
    // formData.append('AuditorOpinion', data?.coordinatorOption || 0)
    formData.append('Comment', data?.coordinatorComment || '')

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteAttachIds', element)
      })

    data?.coordinatorOption?.length > 0 &&
      data?.coordinatorOption?.map((item, index) => {
        console.log('item==>', item)
        formData.set(`AuditorOpinion[${index}]`, item || 0)
      })

    //console.log('CoordinatorOption==>', data?.coordinatorOption)

    keyIdArr.length > 0 &&
      keyIdArr.map((item, index) => {
        formData.set(`Details[${index}].id`, item)
        formData.set(`Details[${index}].trackingResults`, trackingResultsArr[index] || 0)
        formData.set(
          `Details[${index}].trackingResultsDetail`,
          trackingResultsDetailArr[index] || ''
        )
      })

    newFilesIdArr.map((item, index) => {
      formData.set(`Attachs[${index}].Id`, item)
      formData.set(`Attachs[${index}].IssueCode`, newFilesIssueCodeArr[index])

      if (newFiles[index] && newFiles[index][0]?.blobFile) {
        formData.set(`Attachs[${index}].File`, newFiles[index][0].blobFile)
      }

      // newFiles[index].forEach((element) => {
      //   formData.set(`Attachs[${index}].File`, element.blobFile)
      // })
    })

    data.attachFiles &&
      data.attachFiles?.forEach((element, index) => {
        formData.append(`OtherAttachs`, element.blobFile)
      })

    // data.attachFiles &&
    //   data.attachFiles?.forEach((element, index) => {
    //     formData.append(`OtherAttachs[${index}]`, element.blobFile)
    //   })

    // data.attachFiles &&
    //   data.attachFiles?.forEach((element, index) => {
    //     formData.set(`OtherAttachs[${index}]`, element.blobFile)
    //   })

    return formData
  }
  return null
}
